import { render, staticRenderFns } from "./PureComponentFrame.vue?vue&type=template&id=5ce521b5&scoped=true"
import script from "./PureComponentFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./PureComponentFrame.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce521b5",
  null
  
)

export default component.exports